
<v-btn
    class="dropdown-icon"
    :class="style"
    @click="onClick"
    depressed
    color="transparent"
>
    <v-icon >{{ value ? 'fas fa-caret-up' : 'fas fa-caret-down' }}</v-icon>
</v-btn>
